// src/components/DeletePopup.js
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Delete_icon_popup from "../../assets/images/delete_icon_new.svg";

/**
 * Props:
 *  show: boolean
 *  handleClose: func
 *  onDelete: func (called when confirmed)
 *  allowedNames: string[] (list of names that will enable delete if matched)
 */
function DeletePopup({
  show,
  type = "",
  handleClose,
  onDelete,
  allowedNames = [],
}) {
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (!show) setConfirmText("");
  }, [show]);

  // Normalize for comparison
  const normalize = (s = "") => s.toString().trim().toLowerCase();

  // consider match if user typed any allowed name exactly (case-insensitive)
  const isMatched =
    allowedNames.length === 0
      ? confirmText.trim().length > 0 // no restriction: require any text
      : allowedNames.some((n) => normalize(n) === normalize(confirmText));

  const handleConfirmClick = () => {
    if (onDelete) onDelete();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="delete_popup">
      <Modal.Body className="text-center">
        <img src={Delete_icon_popup} alt=" " />
        <h4 className="fs_20 fw_500 mb-0 mt_10">Confirm {type} Deletion</h4>
        <p className="fs_10 mt_10">
          {type === "Formula"
            ? `Are you sure you want to delete the ` +
              allowedNames.join(", ") +
              ` formula?
                  This action cannot be undone and may affect payroll
                                  calculations.`
            : `To confirm, please type the exact name of the ` +
              type +
              `'s full name below.
                      This action is permanent and cannot be undone.`}
        </p>

        {type !== "Formula" && allowedNames.length > 0 && (
          <div style={{ marginBottom: 10 }}>
            <strong>Allowed name:</strong>{" "}
            <span>{allowedNames.join(", ")}</span>
          </div>
        )}

        <div className="common_input_forms">
          <div className="form_group">
            <label>Enter Name</label>
            <input
              type="text"
              className="form-control pl_16"
              placeholder="Enter Name to confirm deletion"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="primary" onClick={handleClose} className="btn_cancel">
          Cancel
        </Button>

        <Button
          variant="danger"
          onClick={handleConfirmClick}
          disabled={!isMatched}
          className="btn_danger"
        >
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeletePopup;
